import * as React from 'react';
import { useMemo, useState } from 'react';
import { BaseReactSettingsCtrlProps } from '../../controllers/BaseReactSettingsCtrl';
import { IServerAdminSettings, ISiteSettingsForServerAdmin } from '../../types/ISite';
import { SectionContainerBaseProps, SettingsFormikContainer } from './GeneralSettingsPageBase';
import { SiteIdValidator } from './sections/site-name-and-id/SiteNameAndIdBusinessLogic';

export interface PropOverridesForSiteCreation {
  hideNameAndId?: boolean;
  hideAvailability?: boolean;
  hideRevisionHistoryLimitWarning?: boolean;
  isDefaultSite?: boolean;
}

export type SiteInfo = {
  siteInfo: Pick<ISiteSettingsForServerAdmin,
    'id'
    | 'licensedUserCount'
    | 'creatorCount'
    | 'explorerCount'
    | 'viewerCount'>;
};

/**
 * A partial list of site settings for server admin.
 * This is meant for individual section components to pick a subset of the overall settings they use
 */
export type SiteSettingsForServerAdminProps<T extends keyof IServerAdminSettings = keyof IServerAdminSettings>
  = PropOverridesForSiteCreation
  & {
  settings: Pick<IServerAdminSettings, T>;
  availability: string;
};

export type OuterSiteSettingsForServerAdminProps = BaseReactSettingsCtrlProps & SectionContainerBaseProps
  & SiteSettingsForServerAdminProps & SiteInfo;

const ReactSiteSettingsForServerAdmin: React.FunctionComponent<OuterSiteSettingsForServerAdminProps> = props => {
  const initErrors = useMemo(() => ({
    settings: {
      urlName: SiteIdValidator(props.settings?.urlName)
    }
  }), [props.settings?.urlName]);

  // the default site will have urlName empty when the component initializes. It shouldn't be recomputed because the user
  // might change it while editing, thus we use it as the initial value of a state.
  const [isDefaultSite] = useState(props.isDefaultSite ?? (props.settings.urlName === ''));
  props = {
    ...props,
    isDefaultSite
  };

  return <SettingsFormikContainer initErrors={initErrors}
                                  initTouched={null}
                                  {...props} />;
};

// The default export is needed for React Dev Tools to see the name of the component. Otherwise it shows up as anonymous
export default ReactSiteSettingsForServerAdmin;
